/** @format */

import React, { useMemo, useState } from "react";
import { Space, Table } from "antd";
import { BreadCrumb } from "../../../../components";
import { ButtonDropdownExport } from "../../../../components/Button";
import notifAlert from "../../../../components/NotifAlert";
import InputSearch from "../../../../components/InputSearch";
import { useHistory } from "react-router-dom";
import FilterPengajuan from "../Component/FilterPengajuan";
import { exportDataPengajuan } from "../Component/ExportDataPengajuan";
import { shallowEqual, useSelector } from "react-redux";
import { columnsSortlist } from "../Component/ColumnTable";
import { useDebounce } from "hooks/useDebounce";
import { safe } from "utils/helper";

const SorlistPengajuanBos = () => {
  const route = useHistory();
  const dataState: any = route ? route.location.state : null;

  const itemBreadcrumb = [
    { path: "/", breadcrumbName: "Home" },
    { path: "/", breadcrumbName: "Pencairan Dokumen BOS" },
    { path: "/", breadcrumbName: "Pengajuan Pencairan" },
    {
      path: "/",
      breadcrumbName: `Batch ${dataState?.batch} Tahap ${dataState?.tahapan}${
        dataState?.jenjang ? ` - ${dataState.jenjang}` : ""
      }`,
    },
  ];

  const { auth, provinsi, kabkota, store } = useSelector(
    (state: any) => ({
      auth: state.auth?.data || null,
      provinsi: state.store?.provinsi,
      kabkota: state.store?.kabkota,
      store: state.store,
    }),
    shallowEqual,
  );
  const tmpTable = dataState?.list_verifikasi;
  const [search, setSearch] = useState<any>(null);
  const debouncedSearch = useDebounce(search, 400);
  const [tmpFilter, setTmpFilter] = useState<any>(null);

  /** Filter Search */
  const dataTable = useMemo(() => {
    let data = tmpTable;

    // search
    if (debouncedSearch) {
      const val = debouncedSearch.toLowerCase();

      data = data.filter((item: any) => {
        return (
          safe(item.provinsi).includes(val) ||
          safe(item.kabkota).includes(val) ||
          safe(item.nama_madrasah).includes(val) ||
          safe(item.nomor_rekening).includes(val) ||
          safe(item.nama_pemilik_rekening).includes(val) ||
          safe(item.nsm).includes(val)
        );
      });
    }

    if (tmpFilter?.provinsi !== undefined) {
      data = data.filter((item) => item.kode_provinsi === tmpFilter?.provinsi);
    }
    if (tmpFilter?.kabkota !== undefined) {
      data = data.filter((item) => item.kode_kabkota === tmpFilter?.kabkota);
    }

    return data;
  }, [debouncedSearch, tmpFilter?.kabkota, tmpFilter?.provinsi, tmpTable]);

  const handleExport = (type: any) => {
    if (dataTable.length > 0) {
      exportDataPengajuan(
        "Pengajuan",
        dataTable,
        type,
        auth?.isTahun,
        store,
        dataState,
      );
    } else {
      notifAlert({
        type: "warning",
        description: "Maaf data tidak tersedia!",
      });
    }
  };
  const columns = useMemo(() => {
    return columnsSortlist(provinsi, kabkota);
  }, [kabkota, provinsi]);

  const handleChangeValues = (values) => {
    setTmpFilter(values);
  };
  return (
    <>
      <BreadCrumb
        routes={itemBreadcrumb}
        title={`List Data  Tahap ${dataState?.tahapan}`}
        back={true}
        toBack={() =>
          route.push({
            pathname: `./`,
            state: {
              page: dataState?.page || 1,
              pageSize: dataState?.pageSize || 10,
              activeTabKey: dataState?.activeTabKey,
            },
          })
        }
      />
      <FilterPengajuan
        handleChangeValues={handleChangeValues}
        dataMadrasah={tmpTable}
      />
      <div className="m-5 p-5 bg-white shadow-md rounded">
        <div className="mb-4 flex justify-end">
          <div className="mr-4">
            <Space wrap>
              <ButtonDropdownExport handleExportFile={handleExport} />
            </Space>
          </div>
          <InputSearch
            className="w-3/4"
            onChange={(e: any) => setSearch(e.currentTarget.value)}
          />
        </div>
        <Table
          //   loading={loading}
          rowKey={(record) => record?.nsm}
          scroll={{ x: "1300" }}
          columns={columns}
          dataSource={dataTable}
          bordered
        />
      </div>
    </>
  );
};

export default SorlistPengajuanBos;
